export enum CompanyPanelEvent {
  Close = 'companyPanelEventClose',
  DetailsSaved = 'companyPanelDetailsSaved',
}

export class OnCompanyPanelClose extends CustomEvent<{}> {
  constructor() {
    super(CompanyPanelEvent.Close, {
      detail: {},
      bubbles: true,
      composed: true,
    });
  }
}
